import { axiosInstance } from "..";
import Cookies from "js-cookie";

export const topicListApi = async() => {
    const response = await axiosInstance.get("api/getTopicList");

    if (response.status !== 200) {
        return null;
    }
    return response.data
}

export const createTopicApi = async(formData: FormData) => {
    var csrfCookie = Cookies.get('csrftoken')
    const config = {
        headers: {
            "Content-Type": "application/json",
        },
        withCredentials: true,
    };

    const response = await axiosInstance.post("api/createTopic", formData, config)
    return response;
}

export const deleteTopicApi = async(topicId: number, userId: string) => {
    var csrfCookie = Cookies.get('csrftoken')
    const config = {
        headers: {
            'X-CSRFToken': csrfCookie? csrfCookie : 0,
        },
        params: {
            topicId: topicId,
            userId: userId
        },
        withCredentials: true,
    };

    const response = await axiosInstance.delete("api/deleteTopic", config);
    return response;
}